import { PricingCopilotMatrixOverview } from './pricing-copilot-matrix-overview';
import { PricingCopilotMatrixOverviewChart } from './pricing-copilot-matrix-overview-chart';
import { PricingCopilotMatrixOverviewPartial } from './pricing-copilot-matrix-overview-partial';
import { PricingCopilotMatrixOverviewSuggestion } from './pricing-copilot-matrix-overview-suggestion';

export class PricingCopilotMatrixOverviewData {
	public latestAttachmentId: string;
	public overviewPartial: (PricingCopilotMatrixOverview & PricingCopilotMatrixOverviewPartial)[];
	public overviewClosed: PricingCopilotMatrixOverview[];
	public overviewYtdSummary: PricingCopilotMatrixOverview[];
	public overviewYoySummary: PricingCopilotMatrixOverview[];
	public overviewChartSixMonth: PricingCopilotMatrixOverviewChart[];
	public overviewChartXYear: PricingCopilotMatrixOverviewChart[];
	public overviewBiggestMovers: PricingCopilotMatrixOverview[];
	public overviewLargestUtilities: PricingCopilotMatrixOverview[];
	public overviewSuggestion: PricingCopilotMatrixOverviewSuggestion;

	constructor(pricingCopilotDashboardData: PricingCopilotMatrixOverviewData) {
		Object.assign(this, pricingCopilotDashboardData);

		this.overviewPartial = this.overviewPartial.map(
			p => new PricingCopilotMatrixOverview(p) as PricingCopilotMatrixOverview & PricingCopilotMatrixOverviewPartial,
		);
		this.overviewClosed = this.overviewClosed.map(c => new PricingCopilotMatrixOverview(c));
		this.overviewYtdSummary = this.overviewYtdSummary.map(c => new PricingCopilotMatrixOverview(c));
		this.overviewYoySummary = this.overviewYoySummary.map(c => new PricingCopilotMatrixOverview(c));
		this.overviewChartSixMonth = this.overviewChartSixMonth.map(c => new PricingCopilotMatrixOverviewChart(c));
		this.overviewChartXYear = this.overviewChartXYear.map(c => new PricingCopilotMatrixOverviewChart(c));
		this.overviewBiggestMovers = this.overviewBiggestMovers.map(c => new PricingCopilotMatrixOverview(c));
		this.overviewLargestUtilities = this.overviewLargestUtilities.map(c => new PricingCopilotMatrixOverview(c));
	}
}
